import { createContext, useContext, useState, useEffect, useRef } from 'react';
import apiClient from '../api/apiClient';

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const initialized = useRef(false);

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;
            initializeUser();
        }
    }, []);

    const initializeUser = async () => {
        try {
            setLoading(true);
            setError(null);

            // ============================================
            // 🚨 ВАЖНО: ПРОВЕРКА TELEGRAM - ОБЯЗАТЕЛЬНА ДЛЯ PROD!
            // ============================================
            // Проверяем, что мы в Telegram WebApp
            // 
            // ⚠️ ПЕРЕД ДЕПЛОЕМ НА DEV/PROD ОБЯЗАТЕЛЬНО РАСКОММЕНТИРУЙТЕ ЭТОТ БЛОК! ⚠️
            // Закомментировано только для работы с mock backend
            // См. подробную инструкцию в файле: MOCK_BACKEND_README.md
            //
            // if (!window.Telegram?.WebApp?.initData) {
            //     throw new Error('Приложение должно быть запущено в Telegram');
            // }
            // ============================================

            // Инициализируем пользователя
            const response = await apiClient.initUser();

            setUser(response.user);
            setConfig(response.config);

            console.log('✅ Пользователь инициализирован:', response.user);
        } catch (err) {
            console.error('❌ Ошибка инициализации пользователя:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const value = {
        user,
        config,
        loading,
        error,
        initializeUser
    };

    return (
        <UserContext.Provider value={value}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUser должен использоваться внутри UserProvider');
    }
    return context;
};
